import axios, { AxiosResponse } from "axios";

import type { GetAccessTokenFunc } from "@digital-services/shell";

import { invalidateTokenUrl } from "./paths";

const scope = import.meta.env.VITE_APP_BACKEND_API_SCOPE as string;

type OnLogoutFunc = (getAccessToken: GetAccessTokenFunc) => Promise<void>;

export default function useInvalidateToken(): OnLogoutFunc {
  // Because according to OAuth protocol B2C token is not invalidated after MSAL signout
  // In FOTA we implemented this custom endpoint to call from Frontend to invalidate token on Backend
  const invalidateToken = async (getAccessToken: GetAccessTokenFunc) => {
    try {
      // when we have "proper" and same MSAL context/instance then accessToken is generated OK
      const accessToken = await getAccessToken([scope]);

      await axios.delete<AxiosResponse>(invalidateTokenUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    } catch (axiosError) {
      if (axios.isAxiosError(axiosError)) {
        throw new Error(axiosError.message);
      }
    }
  };

  return invalidateToken;
}
